import TSideNav from "./TSideNav.vue";

export default TSideNav;
